import React, { createContext } from 'react';
import {
  bool,
  node,
  string,
  func,
  shape,
  arrayOf
} from 'prop-types';

import { suppliedEstimateData as dataShape } from '../constants/supplied-data-shape';

export const RentalEstimateContext = createContext();

const RentalEstimateProvider = ({
  accessories,
  updateAccessories,
  graphQlEnabled,
  pickupTime,
  returnTime,
  storeId,
  rentalCategory,
  rentalSubCategory,
  svocId,
  suppliedEstimateData,
  damageProtection,
  damageProtectionChange,
  deliveryAddress,
  hideDeposit,
  children,
  hideSuccessMsg,
  hideDue,
}) => {
  const contextValue = React.useMemo(() => ({
    accessories,
    updateAccessories,
    graphQlEnabled,
    pickupTime,
    returnTime,
    storeId,
    rentalCategory,
    rentalSubCategory,
    svocId,
    suppliedEstimateData,
    damageProtection,
    damageProtectionChange,
    deliveryAddress,
    hideDeposit,
    hideSuccessMsg,
    hideDue
  }), [
    accessories,
    updateAccessories,
    graphQlEnabled,
    pickupTime,
    returnTime,
    storeId,
    rentalCategory,
    rentalSubCategory,
    svocId,
    suppliedEstimateData,
    damageProtection,
    damageProtectionChange,
    deliveryAddress,
    hideDeposit,
    hideSuccessMsg,
    hideDue
  ]);

  return (
    <RentalEstimateContext.Provider value={contextValue}>
      {children}
    </RentalEstimateContext.Provider>
  );
};

RentalEstimateProvider.propTypes = {
  accessories: arrayOf(shape({
    id: string.isRequired,
    description: string.isRequired,
    price: string.isRequired,
    selected: bool.isRequired
  })),
  updateAccessories: func,
  graphQlEnabled: bool.isRequired,
  pickupTime: string.isRequired,
  returnTime: string.isRequired,
  storeId: string,
  rentalCategory: string.isRequired,
  rentalSubCategory: string.isRequired,
  svocId: string,
  suppliedEstimateData: dataShape,
  damageProtection: bool.isRequired,
  damageProtectionChange: func.isRequired,
  deliveryAddress: shape({
    street: string,
    city: string,
    state: string,
    zipCode: string
  }),
  hideDeposit: bool.isRequired,
  children: node.isRequired,
  hideSuccessMsg: bool,
  hideDue: bool
};

RentalEstimateProvider.defaultProps = {
  accessories: [],
  updateAccessories: () => { },
  hideSuccessMsg: false,
  svocId: null,
  storeId: null,
  deliveryAddress: null,
  suppliedEstimateData: {},
  hideDue: false
};

RentalEstimateProvider.dataModel = {};

export default RentalEstimateProvider;
